module.exports = __webpack_public_path__ + "img/logga_upplevelser.dd00a206.png";